var React = require('react');

function Cupboard (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M33.05 17.5072V14.2336H35.6L33.95 6H24.15L22.5 14.184H28.65V21.4256H10.5C10.2 21.4256 10 21.624 10 21.9216V46.8208C10 47.1184 10.2 47.3168 10.5 47.3168H13.55V51.1856H14.55V47.3168H43.55V51.1856H44.55V47.3168H47.6C47.9 47.3168 48.1 47.1184 48.1 46.8208V21.9712C48.1 21.6736 47.9 21.4752 47.6 21.4752H29.6V14.2336H32.05V17.5072H33.05ZM11 30.4032H28.55V46.3744H11V30.4032ZM29.55 46.3744V30.4032H47.1V46.3744H29.55ZM47.1 29.4112H11V22.4672H47.1V29.4112ZM24.95 6.992H33.1L34.35 13.192H23.7L24.95 6.992Z","fill":"black"}));
}

Cupboard.defaultProps = {"width":"57","height":"57","viewBox":"0 0 57 57","fill":"none"};

module.exports = Cupboard;

Cupboard.default = Cupboard;
